import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  AccordionSummary,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import MomentTz from 'moment-timezone';
import _ from 'lodash';

import {
  IStateProps,
  IDispatchProps,
  IProps,
} from './interfaces';
import {
  AccordionContainer,
  AccordionDetailsContainer,
} from './styles';
import { IAppState } from '../../../../state/reducers';
import {
  toggleAssetShares,
  queryAssetShareLogs,
  resetAssetShares,
} from '../../../../state/assetShares';
import { isOwnerOfAsset } from '../../../../utils/assetDetails/isOwnerOfAsset';
import { selectIsUserVaultSuperAdmin, selectUserRole } from '../../../../state/user/userOrgRole';
import Warning from '../../Warning';

const headCells = [
  { id: 'recipient', label: 'Email' },
  { id: 'actionDate', label: 'Sent' },
  { id: 'expiration', label: 'Expiration' },
];

class AssetShares extends PureComponent<IProps> {
  handleToggle = () => {
    const {
      isOpen,
      rawAssetDetails,
      onQueryAssetShares,
      onResetAssetShares,
    } = this.props;

    if (isOpen) {
      onResetAssetShares();
    } else {
      onQueryAssetShares(rawAssetDetails._id, true);
    }
  };

  componentDidUpdate = (prevProps: IProps) => {
    const { onResetAssetShares, rawAssetDetails } = this.props;

    if (!_.isEqual(rawAssetDetails, prevProps.rawAssetDetails)) {
      onResetAssetShares();
    }
  };

  render = () => {
    const {
      rawAssetDetails,
      isOpen,
      shares,
      securityProfiles: { isLoaded, idValueMapping },
      userRole,
      isSuperAdmin,
    } = this.props;

    const isOwner = isLoaded ? isOwnerOfAsset(userRole, rawAssetDetails, idValueMapping) : false;

    if (!isOwner && !isSuperAdmin) {
      return null;
    }

    return (
      <AccordionContainer
        expanded={isOpen}
        onChange={this.handleToggle}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
        >
          <Typography>Share History</Typography>
        </AccordionSummary>
        <AccordionDetailsContainer>
          <Warning
            isWarning={shares.length === 0}
            message="Asset not yet shared"
            fullWidth
          />
          {shares.length > 0 && (
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    {headCells.map((cell) => (
                      <TableCell
                        key={cell.id}
                        align="center"
                      >
                        {cell.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {shares.map(({ recipient, created, expiration }) => (
                    <TableRow>
                      <TableCell align="center">
                        {recipient}
                      </TableCell>
                      <TableCell align="center">
                        {MomentTz.tz(created, MomentTz.tz.guess()).format('L LT')}
                      </TableCell>
                      <TableCell align="center">
                        {MomentTz.tz(expiration, MomentTz.tz.guess()).format('L LT')}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </AccordionDetailsContainer>
      </AccordionContainer>
    );
  };
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  isOpen: state.assetShares.isOpen,
  isQuerying: state.assetShares.isQuerying,
  shares: state.assetShares.shares,
  securityProfiles: state.securityProfiles,
  userRole: selectUserRole(state),
  isSuperAdmin: selectIsUserVaultSuperAdmin(state),
});

const mapDispatchToProps: IDispatchProps = {
  onToggleAssetShares: toggleAssetShares,
  onQueryAssetShares: queryAssetShareLogs,
  onResetAssetShares: resetAssetShares,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AssetShares);
